<template lang="html">
  <div id="InformationNotification">
    <h1>未通知ユーザー一覧</h1>
    <el-table
      :data="userlistFiltered"
      style="width: 80%; margin: 0 auto"
      >
      <el-table-column
      prop="user_id"
      label="ID"
      width="50">
      </el-table-column>
      <el-table-column
      prop="user_name"
      label="ユーザー名"
      width="150">
      </el-table-column>
      <el-table-column
      prop="fullname"
      label="氏名"
      width="150">
      </el-table-column>
      <el-table-column
      prop="kana"
      label="フリガナ">
      </el-table-column>
      <el-table-column
      prop="user_type"
      label="種類">
      </el-table-column>
      <el-table-column
      label="ステータス">
      <template slot-scope="scope">
        {{userStatusDisplay(scope.row.user_status)}}
      </template>
      </el-table-column>
      <el-table-column
      prop=""
      label="">
      <template slot-scope="scope">
        <el-button type="danger" @click="show(scope.row)">通知</el-button>
      </template>
      </el-table-column>
    </el-table>
    <modal name="important_info"
       class="important_info"
       width="60%"
       v-loading="loading">
       <h1>通知作成</h1>
       <h2>{{modal_form.fullname}} 様</h2>
       <div class="important_text">
         <table>
           <tr>
             <th>ID:</th>
             <td><el-input placeholder="ID" v-model="modal_form.user_name"></el-input></td>
           </tr>
           <tr>
             <th>pass:</th>
             <td><el-input type="password" placeholder="パスワード" v-model="modal_form.pass" show-password></el-input></td>
           </tr>
           <tr>
             <th>mail:</th>
             <td><el-input placeholder="info@kyushinjuku.com" v-model="modal_form.mail_address"></el-input></td>
           </tr>
         </table>
         <el-button type="danger" @click="confirm">通知</el-button>
       </div>
   </modal>
   <el-dialog
      title="確認画面"
      :visible.sync="dialogVisible"
      width="30%"
      >
      <span>
        <p>以下の内容で情報を変更し通知メールを送信します。</p><br>
        <span class="dialog_info">
          <p>{{ this.modal_form.fullname }}様宛に</p>
          <table>
            <tr>
              <th>ID</th><td>:</td><td>{{ this.modal_form.user_name }}</td>
            </tr>
            <tr>
              <th>パスワード</th><td>:</td><td>{{ this.modal_form.pass }}</td>
            </tr>
            <tr>
              <th>メールアドレス</th><td>:</td><td>{{ this.modal_form.mail_address }}</td>
            </tr>
          </table>
        </span>
      </span><br>
      <p>よろしいですか？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false, loading = false">キャンセル</el-button>
        <el-button type="primary" @click="sendMail">送信</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  mapActions
} from 'vuex'
export default {
  name: 'InformationNotification',
  data () {
    return {
      modal_switch: false,
      modal_form: {
        user_id: '',
        user_name: '',
        fullname: '',
        pass: '',
        mail_address: ''
      },
      loading: false,
      dialogVisible: false
    }
  },
  methods: {
    ...mapActions([
      'updateUserList',
      'changeUserName',
      'changeUserPassword',
      'sendUserInfoMail'
    ]),
    show (userData) {
      this.modal_form.user_id = userData.user_id
      this.modal_form.fullname = userData.fullname
      this.modal_form.user_name = userData.user_name
      this.modal_form.mail_address = userData.mail_address
      this.$modal.show('important_info')
    },
    hide () {
      this.$modal.hide('important_info')
    },
    sendMail () {
      // ダイアログを非表示に
      this.dialogVisible = false
      // ロード画面を表示
      this.loading = true
      // usernameの書き換え
      this.changeUserName({
        id: this.modal_form.user_id,
        newUserName: this.modal_form.user_name
      }).then((res) => {
        if (res) {
          this.$notify({
            title: '成功',
            message: 'ユーザ名の変更に成功しました',
            type: 'success',
            offset: 50,
            duration: 1200
          })
        }
      })
      // passの書き換え
      this.changeUserPassword({
        id: this.modal_form.user_id,
        currentPassword: this.current_password,
        newPassword: this.modal_form.pass
      }).then((res) => {
        if (res) {
          this.$notify({
            title: '成功',
            message: 'パスワードの変更に成功しました',
            type: 'success',
            offset: 50,
            duration: 1500
          })
        }
      })
      // 通知メールの送信＆スプレッドシートにログの書き込み
      console.log(this.modal_form)
      this.sendUserInfoMail({
        fullname: this.modal_form.fullname,
        user_name: this.modal_form.user_name,
        pass: this.modal_form.pass,
        mail_address: this.modal_form.mail_address
      }).then((res) => {
        this.$notify({
          title: '成功',
          message: '通知メールを送信しました',
          type: 'success',
          offset: 50,
          duration: 1000
        })
      })
      this.loading = false
      this.$modal.hide('important_info')
      this.updateUserList()
    },
    confirm () {
      // バリデーション
      if (this.modal_form.user_name === '') {
        this.$notify({
          title: '失敗',
          message: 'IDが記入されていません',
          type: 'error',
          offset: 50
        })
        return
      }
      if (this.modal_form.pass === '') {
        this.$notify({
          title: '失敗',
          message: 'パスワードが記入されていません',
          type: 'error',
          offset: 50
        })
        return
      }
      if (this.modal_form.mail_address === null) {
        this.$notify({
          title: '失敗',
          message: 'メールアドレスが記入されていません',
          type: 'error',
          offset: 50
        })
        return
      }
      // ダイアログの表示
      this.dialogVisible = true
    },
    userStatusDisplay (status) {
      if (status === 'trial') {
        return '体験'
      } else if (status === 'temporal') {
        return '短期'
      } else if (status === 'normal') {
        return '通常'
      } else if (status === 'temp/temp') {
        return '短期'
      } else if (status === 'temp/norm') {
        return '通常/短期'
      } else {
        return 'Unknown'
      }
    }
  },
  computed: {
    userlistFiltered () {
      return this.$store.state.userlist.filter((user, index, array) => {
        return (user.user_name.match('tanki') && (user.user_status === 'temp/norm' || user.user_status === 'nomal'))
      })
    }
  },
  mounted () {
    this.updateUserList()
  }
}
</script>

<style lang="css" scoped>
#userList {
  overflow-y: scroll;
}
#userListTable {
  width: 100%;
  margin: auto;
}
.itemEven {
  background-color: #ffffcc
}
thead>tr>th {
  text-align: center;
}
tbody>tr:hover {
  background-color: #ffcccc
}
.cp_iptxt {
	position: relative;
	width: 20%;
	margin: 10px 3%;
}
.cp_iptxt input[type='text'] {
	font: 15px/24px sans-serif;
	box-sizing: border-box;
	width: 100%;
	letter-spacing: 1px;
	padding-left: 4em;
}
.cp_iptxt input[type='text']:focus {
	outline: none;
}
.ef {
	padding: 4px 0;
	border: 0;
	border-bottom: 1px solid #1b2538;
	background-color: transparent;
}
.ef ~ .focus_line {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 0;
	height: 2px;
	transition: 0.4s;
	background-color: #da3c41;
}
.ef:focus ~ .focus_line,
.cp_iptxt.ef ~ .focus_line {
	width: 100%;
	transition: 0.4s;
}
.ef ~ label {
	position: absolute;
	z-index: -1;
	top: 4px;
	left: 0;
	width: 100%;
	transition: 0.3s;
	letter-spacing: 0.5px;
	color: #aaaaaa;
}
.ef:focus ~ label, .cp_iptxt.ef ~ label {
	font-size: 12px;
	top: -16px;
	transition: 0.3s;
	color: #da3c41;
}
.important_info h2{
  text-align: center;
}
.important_text{
  text-align: center;
  margin: 0 auto;
  margin-left: 20%;
}
.dialog_info table{
  width: 80%;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// InformationNotification.vue?11d563e0